import { Segmented, Button, Popover } from "antd"
import styles from "./index.module.scss"
import SingleUploader from "../SingleUploader"
import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import { GenerateContext } from "../../../hooks/GenerateContext"
import PSAIModal from "@PSAIComponents/PSAIModal"
import MattingOpt from '@view/compoents/MattingOpt/MattingOpt';
import {
    INPUT_IMAGE_TYPE, TRYON_CLOTH_TYPE, IMAGE_TYPE, UPLOAD_SOURCE, SELECT_ORG_TYPE,
    SEGMENT_ALGO_TYPE, RESOLUTION_RATIO, COMMODITY_SCENE_MODE, CLOTH_COLOR_TYPE, POSE_FANTASY_MODE
} from "@utils/CONST"
import Utils from "@utils/utils"
import useResizeObserver from "@utils/useResizeObserver"
import CommodityDrag from "../CommodityDrag"
import eventBus from "@utils/eventBus"
import { AppContext } from '@utils/AppContext';
import Iconfont from '@utils/Iconfont';

const CommodityDragContainer = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        getDragScale: () => dragScale,
    }))

    const {
        positionOptValue,
    } = props

    const [dragScale, setDragScale] = useState(positionOptValue?.dragScale || [])

    // useEffect(() => {
    //     console.log('positionOptValue', positionOptValue)
    // }, [positionOptValue])

    // 工作台的尺寸
    const [deskWidth, setDeskWidth] = useState(0)
    const [deskHeight, setDeskHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setDeskWidth(entry.contentRect.width)
            setDeskHeight(entry.contentRect.height)
        }
    })

    return (
        <div ref={targetRef} className={styles.CommodityDragContainer}>
            {
                deskWidth && deskHeight &&
                <CommodityDrag
                    {...positionOptValue}
                    deskSize={{
                        width: deskWidth,
                        height: deskHeight,
                    }}
                    onDragChange={setDragScale}
                />
            }
        </div>
    )
})
const ClothesUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        currentInputType, setCurrentInputType,
        // 输入图
        inputImage, setInputImage,
        // 输入图宽度
        inputImageWidth, setInputImageWidth,
        // 输入图高度
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,
        inputImageNpyId, setInputImageNpyId,
        inputImageClothType, setInputImageClothType,
        // 上装
        topInputImage, setTopInputImage,
        topInputImageWidth, setTopInputImageWidth,
        topInputImageHeight, setTopInputImageHeight,
        topInputImageMaskId, setTopInputImageMaskId,
        topInputImageOriginalMask, setTopInputImageOriginalMask,
        topInputImageEditedMask, setTopInputImageEditedMask,
        topInputImageNpyId, setTopInputImageNpyId,
        // 下装
        bottomInputImage, setBottomInputImage,
        bottomInputImageWidth, setBottomInputImageWidth,
        bottomInputImageHeight, setBottomInputImageHeight,
        bottomInputImageMaskId, setBottomInputImageMaskId,
        bottomInputImageOriginalMask, setBottomInputImageOriginalMask,
        bottomInputImageEditedMask, setBottomInputImageEditedMask,
        bottomInputImageNpyId, setBottomInputImageNpyId,
        getClothMaskOutput,
        getInteractiveNpyId,

        inputImageLoading, setInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
    } = useContext(GenerateContext)

    // 单图上传
    const handleSingleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothType) setInputImageClothType(res.clothType)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
    }
    // 上装
    const handleTopChange = async (res) => {
        setProjectId()
        let matchClothType = res.clothType
        let matchClothTypeCN = "未知"
        let inputClothTypeCN = ""
        let clothTypeRequire = TRYON_CLOTH_TYPE.TOP
        let clothTypeRequireCN = "上装"
        if (matchClothType == TRYON_CLOTH_TYPE.TOP) {
            matchClothTypeCN = "上装"
            inputClothTypeCN = "上装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.BOTTOM) {
            matchClothTypeCN = "下装"
            inputClothTypeCN = "下装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.DRESS) {
            matchClothTypeCN = "连体装"
            inputClothTypeCN = "下装"
        }
        if (matchClothType != clothTypeRequire) {
            PSAIModal.confirm({
                headTitle: "图片填充",
                content: (
                    <div className={styles.InputImageUploaderModalContent}>
                        <img src={res.inputImage} style={{ width: 128, height: 128 }} />
                        <div>
                            <span>{`算法检测到您上传的图片可能为${matchClothTypeCN}`}</span>
                            <span>{`是否作为${inputClothTypeCN}填入`}</span>
                        </div>
                    </div>
                ),
                okText: `是${inputClothTypeCN}，帮我填入`,
                cancelText: `是${clothTypeRequireCN}`,
                onOk() {
                    if (res.inputImage) setBottomInputImage(res.inputImage)
                    if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
                    setBottomInputImageEditedMask()
                    setBottomInputImageNpyId()
                },
                onCancel() {
                    if (res.inputImage) setTopInputImage(res.inputImage)
                    if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
                    setTopInputImageEditedMask()
                    setTopInputImageNpyId()
                },
                onClose: () => { }
            })
        } else {
            if (res.inputImage) setTopInputImage(res.inputImage)
            if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
            if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
            if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
            if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
            setTopInputImageEditedMask()
            setTopInputImageNpyId()
        }
    }
    // 下装
    const handleBottomChange = async (res) => {
        setProjectId()
        let matchClothType = res.clothType
        let matchClothTypeCN = "未知"
        let inputClothTypeCN = ""
        let clothTypeRequire = TRYON_CLOTH_TYPE.BOTTOM
        let clothTypeRequireCN = "下装"
        if (matchClothType == TRYON_CLOTH_TYPE.TOP) {
            matchClothTypeCN = "上装"
            inputClothTypeCN = "上装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.BOTTOM) {
            matchClothTypeCN = "下装"
            inputClothTypeCN = "下装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.DRESS) {
            matchClothTypeCN = "连体装"
            inputClothTypeCN = "上装"
        }
        if (matchClothType != clothTypeRequire) {
            PSAIModal.confirm({
                headTitle: "图片填充",
                content: (
                    <div className={styles.InputImageUploaderModalContent}>
                        <img src={res.inputImage} style={{ width: 128, height: 128 }} />
                        <div>
                            <span>{`算法检测到您上传的图片可能为${matchClothTypeCN}`}</span>
                            <span>{`是否作为${inputClothTypeCN}填入`}</span>
                        </div>
                    </div>
                ),
                okText: `是${inputClothTypeCN}，帮我填入`,
                cancelText: `是${clothTypeRequireCN}`,
                onOk() {
                    if (res.inputImage) setTopInputImage(res.inputImage)
                    if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
                    setTopInputImageEditedMask()
                    setTopInputImageNpyId()
                },
                onCancel() {
                    if (res.inputImage) setBottomInputImage(res.inputImage)
                    if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
                    setBottomInputImageEditedMask()
                    setBottomInputImageNpyId()
                },
                onClose: () => { }
            })
        } else {
            if (res.inputImage) setBottomInputImage(res.inputImage)
            if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
            if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
            if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
            if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
            setBottomInputImageEditedMask()
            setBottomInputImageNpyId()
        }
    }
    // 单件服装/上下搭配
    const segmentedItems = [{
        label: "单件服装",
        value: INPUT_IMAGE_TYPE.SINGLE,
    }, {
        label: "上下搭配",
        value: INPUT_IMAGE_TYPE.MULTI,
    }]
    // 单件服装/上下搭配切换时，输入图相互带入
    const handlerInputTypeChange = value => {
        setProjectId()
        if (value == INPUT_IMAGE_TYPE.SINGLE) { // 单件服装
            if (topInputImage) {
                setInputImage(topInputImage)
                setInputImageWidth(topInputImageWidth)
                setInputImageHeight(topInputImageHeight)
                setInputImageMaskId(topInputImageMaskId)
                setInputImageOriginalMask(topInputImageOriginalMask)
                setInputImageEditedMask(topInputImageEditedMask)
                setInputImageNpyId(topInputImageNpyId)
                setInputImageClothType(TRYON_CLOTH_TYPE.TOP)
            } else if (bottomInputImage) {
                setInputImage(bottomInputImage)
                setInputImageWidth(bottomInputImageWidth)
                setInputImageHeight(bottomInputImageHeight)
                setInputImageMaskId(bottomInputImageMaskId)
                setInputImageOriginalMask(bottomInputImageOriginalMask)
                setInputImageEditedMask(bottomInputImageEditedMask)
                setInputImageNpyId(bottomInputImageNpyId)
                setInputImageClothType(TRYON_CLOTH_TYPE.BOTTOM)
            }
            setTopInputImage()
            setTopInputImageWidth()
            setTopInputImageHeight()
            setTopInputImageMaskId()
            setTopInputImageOriginalMask()
            setTopInputImageEditedMask()
            setTopInputImageNpyId()
            setBottomInputImage()
            setBottomInputImageWidth()
            setBottomInputImageHeight()
            setBottomInputImageMaskId()
            setBottomInputImageOriginalMask()
            setBottomInputImageEditedMask()
            setBottomInputImageNpyId()
        } else if (value == INPUT_IMAGE_TYPE.MULTI) { // 上下搭配
            if (inputImage) {
                if (inputImageClothType == TRYON_CLOTH_TYPE.TOP) {
                    setTopInputImage(inputImage)
                    setTopInputImageWidth(inputImageWidth)
                    setTopInputImageHeight(inputImageHeight)
                    setTopInputImageMaskId(inputImageMaskId)
                    setTopInputImageOriginalMask(inputImageOriginalMask)
                    setTopInputImageEditedMask(inputImageEditedMask)
                    setTopInputImageNpyId(inputImageNpyId)
                } else if (inputImageClothType == TRYON_CLOTH_TYPE.BOTTOM) {
                    setBottomInputImage(inputImage)
                    setBottomInputImageWidth(inputImageWidth)
                    setBottomInputImageHeight(inputImageHeight)
                    setBottomInputImageMaskId(inputImageMaskId)
                    setBottomInputImageOriginalMask(inputImageOriginalMask)
                    setBottomInputImageEditedMask(inputImageEditedMask)
                    setBottomInputImageNpyId(inputImageNpyId)
                } else if (inputImageClothType == TRYON_CLOTH_TYPE.DRESS) {
                    setTopInputImage(inputImage)
                    setTopInputImageWidth(inputImageWidth)
                    setTopInputImageHeight(inputImageHeight)
                    setTopInputImageMaskId(inputImageMaskId)
                    setTopInputImageOriginalMask(inputImageOriginalMask)
                    setTopInputImageEditedMask(inputImageEditedMask)
                    setTopInputImageNpyId(inputImageNpyId)
                }
                setInputImage()
                setInputImageWidth()
                setInputImageHeight()
                setInputImageMaskId()
                setInputImageOriginalMask()
                setInputImageEditedMask()
                setInputImageNpyId()
                setInputImageClothType()
            }
        }
        setCurrentInputType(value)
    }
    // 抠图优化
    const handleMattingOptSingle = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }
    const handleMattingOptMulti = async (key) => {
        const groups = []
        // TRYON_CLOTH_TYPE.TOP
        if (topInputImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (topInputImageEditedMask) {
                binaryMask = topInputImageEditedMask.binaryMask
                foregroundAlphaMask = topInputImageEditedMask.foregroundAlphaMask
                foregroundMask = topInputImageEditedMask.foregroundMask
            } else {
                binaryMask = topInputImageOriginalMask?.binaryMask
                foregroundAlphaMask = topInputImageOriginalMask?.foregroundAlphaMask
                foregroundMask = topInputImageOriginalMask?.foregroundMask
            }
            if (topInputImageNpyId) {
                interactiveNpyId = topInputImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(topInputImage, binaryMask)
                if (!interactiveNpyId) return
                setTopInputImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: topInputImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        // TRYON_CLOTH_TYPE.BOTTOM
        if (bottomInputImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (bottomInputImageEditedMask) {
                binaryMask = bottomInputImageEditedMask.binaryMask
                foregroundAlphaMask = bottomInputImageEditedMask.foregroundAlphaMask
                foregroundMask = bottomInputImageEditedMask.foregroundMask
            } else {
                binaryMask = bottomInputImageOriginalMask?.binaryMask
                foregroundAlphaMask = bottomInputImageOriginalMask?.foregroundAlphaMask
                foregroundMask = bottomInputImageOriginalMask?.foregroundMask
            }
            if (bottomInputImageNpyId) {
                interactiveNpyId = bottomInputImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(bottomInputImage, binaryMask)
                if (!interactiveNpyId) return
                setBottomInputImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: bottomInputImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        const current = groups.findIndex(item => item.inputImage == key)
        // 发起抠图优化
        props.onMattingOpt(current, groups, resList => {
            for (let i = 0; i < resList.length; i++) {
                const res = resList[i]
                if (!res) continue
                if (i == 0) {
                    setTopInputImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                } else if (i == 1) {
                    setBottomInputImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                }
            }
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImageEditedMask.foregroundMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImageOriginalMask.foregroundMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId])
    // 上装显示图
    const [topShowValue, setTopShowValue] = useState([])
    useEffect(() => {
        if (topInputImageEditedMask) setTopShowValue([topInputImageEditedMask.foregroundMask])
        else if (topInputImageOriginalMask) setTopShowValue([topInputImageOriginalMask.foregroundMask])
        else if (topInputImageMaskId) getClothMaskOutput(topInputImageMaskId).then(setTopInputImageOriginalMask)
    }, [topInputImageOriginalMask, topInputImageEditedMask, topInputImageMaskId])
    // 下装显示图
    const [bottomShowValue, setBottomShowValue] = useState([])
    useEffect(() => {
        if (bottomInputImageEditedMask) setBottomShowValue([bottomInputImageEditedMask.foregroundMask])
        else if (bottomInputImageOriginalMask) setBottomShowValue([bottomInputImageOriginalMask.foregroundMask])
        else if (bottomInputImageMaskId) getClothMaskOutput(bottomInputImageMaskId).then(setBottomInputImageOriginalMask)
    }, [bottomInputImageOriginalMask, bottomInputImageEditedMask, bottomInputImageMaskId])

    return (
        <div className={styles.Container}>
            <Segmented
                block
                options={segmentedItems}
                value={currentInputType}
                onChange={handlerInputTypeChange}
            />
            <div className={styles.Header}>
                <span>衣服平铺图</span>
            </div>
            <div className={styles.Content}>
                {
                    currentInputType == INPUT_IMAGE_TYPE.SINGLE ?
                        <div className={styles.SingleUploader}>
                            <SingleUploader
                                key="single"
                                value={inputImage}
                                showValue={singleShowValue}
                                clothType={inputImageClothType}
                                showClothType
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_DRESS}
                                dragTips="释放鼠标添加服装"
                                uploadText="衣服图"
                                uploadIcon="uploadClothIcon.png"
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={inputImageLoading}
                                setLoading={setInputImageLoading}
                                onChange={handleSingleChange}
                                onMattingOpt={handleMattingOptSingle}
                            />
                        </div> :
                        <div className={styles.MultiUploader}>
                            <SingleUploader
                                key="top"
                                value={topInputImage}
                                showValue={topShowValue}
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_TOP}
                                dragTips="释放鼠标上传上装"
                                uploadText="上装"
                                uploadIcon="uploadClothIcon.png"
                                paddingInline={39}
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={topInputImageLoading}
                                setLoading={setTopInputImageLoading}
                                onChange={handleTopChange}
                                onMattingOpt={() => handleMattingOptMulti(topInputImage)}
                            />
                            <SingleUploader
                                key="bottom"
                                value={bottomInputImage}
                                showValue={bottomShowValue}
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_BOTTOM}
                                dragTips="释放鼠标上传下装"
                                uploadText="下装"
                                uploadIcon="uploadClothIcon.png"
                                paddingInline={39}
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={bottomInputImageLoading}
                                setLoading={setBottomInputImageLoading}
                                onChange={handleBottomChange}
                                onMattingOpt={() => handleMattingOptMulti(bottomInputImage)}
                            />
                        </div>
                }
            </div>
        </div>
    )
})
const ShoesUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        currentInputType, setCurrentInputType,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        no1MultiAngleImage, setNo1MultiAngleImage,
        no1MultiAngleImageWidth, setNo1MultiAngleImageWidth,
        no1MultiAngleImageHeight, setNo1MultiAngleImageHeight,
        no1MultiAngleImageMaskId, setNo1MultiAngleImageMaskId,
        no1MultiAngleImageOriginalMask, setNo1MultiAngleImageOriginalMask,
        no1MultiAngleImageEditedMask, setNo1MultiAngleImageEditedMask,
        no1MultiAngleImageNpyId, setNo1MultiAngleImageNpyId,

        no2MultiAngleImage, setNo2MultiAngleImage,
        no2MultiAngleImageWidth, setNo2MultiAngleImageWidth,
        no2MultiAngleImageHeight, setNo2MultiAngleImageHeight,
        no2MultiAngleImageMaskId, setNo2MultiAngleImageMaskId,
        no2MultiAngleImageOriginalMask, setNo2MultiAngleImageOriginalMask,
        no2MultiAngleImageEditedMask, setNo2MultiAngleImageEditedMask,
        no2MultiAngleImageNpyId, setNo2MultiAngleImageNpyId,

        getClothMaskOutput,
        getInteractiveNpyId,

        inputImageLoading, setInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
    } = useContext(GenerateContext)

    const segmentedItems = [{
        label: "单视角图",
        value: INPUT_IMAGE_TYPE.SINGLE,
    }, {
        label: "多视角图",
        value: INPUT_IMAGE_TYPE.MULTI,
    }]

    // 单视角图/多视角图切换
    const handlerInputTypeChange = (value) => {
        setProjectId()
        setCurrentInputType(value)
    }
    // 单件上传
    const handleSingleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
    }
    // 多视角图上传
    const handleFirstChange = async (res) => {
        setProjectId()
        if (res.inputImage) setNo1MultiAngleImage(res.inputImage)
        if (res.inputImageWidth) setNo1MultiAngleImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setNo1MultiAngleImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setNo1MultiAngleImageMaskId(res.clothMaskId)
        if (res.originalMask) setNo1MultiAngleImageOriginalMask(res.originalMask)
        setNo1MultiAngleImageEditedMask()
        setNo1MultiAngleImageNpyId()
    }
    // 多视角图上传
    const handleSecondChange = async (res) => {
        setProjectId()
        if (res.inputImage) setNo2MultiAngleImage(res.inputImage)
        if (res.inputImageWidth) setNo2MultiAngleImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setNo2MultiAngleImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setNo2MultiAngleImageMaskId(res.clothMaskId)
        if (res.originalMask) setNo2MultiAngleImageOriginalMask(res.originalMask)
        setNo2MultiAngleImageEditedMask()
        setNo2MultiAngleImageNpyId()
    }
    // 抠图优化
    const handleMattingOptSingle = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }
    // 多视角图抠图优化
    const handleMattingOptMulti = async (key) => {
        const groups = []
        if (inputImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (inputImageEditedMask) {
                binaryMask = inputImageEditedMask.binaryMask
                foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
                foregroundMask = inputImageEditedMask.foregroundMask
            } else {
                binaryMask = inputImageOriginalMask?.binaryMask
                foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
                foregroundMask = inputImageOriginalMask?.foregroundMask
            }
            if (inputImageNpyId) {
                interactiveNpyId = inputImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
                if (!interactiveNpyId) return
                setInputImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        if (no1MultiAngleImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (no1MultiAngleImageEditedMask) {
                binaryMask = no1MultiAngleImageEditedMask.binaryMask
                foregroundAlphaMask = no1MultiAngleImageEditedMask.foregroundAlphaMask
                foregroundMask = no1MultiAngleImageEditedMask.foregroundMask
            } else {
                binaryMask = no1MultiAngleImageOriginalMask?.binaryMask
                foregroundAlphaMask = no1MultiAngleImageOriginalMask?.foregroundAlphaMask
                foregroundMask = no1MultiAngleImageOriginalMask?.foregroundMask
            }
            if (no1MultiAngleImageNpyId) {
                interactiveNpyId = no1MultiAngleImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(no1MultiAngleImage, binaryMask)
                if (!interactiveNpyId) return
                setNo1MultiAngleImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: no1MultiAngleImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        if (no2MultiAngleImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (no2MultiAngleImageEditedMask) {
                binaryMask = no2MultiAngleImageEditedMask.binaryMask
                foregroundAlphaMask = no2MultiAngleImageEditedMask.foregroundAlphaMask
                foregroundMask = no2MultiAngleImageEditedMask.foregroundMask
            } else {
                binaryMask = no2MultiAngleImageOriginalMask?.binaryMask
                foregroundAlphaMask = no2MultiAngleImageOriginalMask?.foregroundAlphaMask
                foregroundMask = no2MultiAngleImageOriginalMask?.foregroundMask
            }
            if (no2MultiAngleImageNpyId) {
                interactiveNpyId = no2MultiAngleImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(no2MultiAngleImage, binaryMask)
                if (!interactiveNpyId) return
                setNo2MultiAngleImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: no2MultiAngleImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        const current = groups.findIndex(item => item.inputImage == key)
        // 发起抠图优化
        props.onMattingOpt(current, groups, resList => {
            for (let i = 0; i < resList.length; i++) {
                const res = resList[i]
                if (!res) continue
                if (i == 0) {
                    setInputImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                } else if (i == 1) {
                    setNo1MultiAngleImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                } else if (i == 2) {
                    setNo2MultiAngleImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                }
            }
        })
    }
    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImageEditedMask.foregroundMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImageOriginalMask.foregroundMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId])
    // 多视角图显示图
    const [no1MultiAngleShowValue, setNo1MultiAngleShowValue] = useState([])
    useEffect(() => {
        if (no1MultiAngleImageEditedMask) setNo1MultiAngleShowValue([no1MultiAngleImageEditedMask.foregroundMask])
        else if (no1MultiAngleImageOriginalMask) setNo1MultiAngleShowValue([no1MultiAngleImageOriginalMask.foregroundMask])
        else if (no1MultiAngleImageMaskId) getClothMaskOutput(no1MultiAngleImageMaskId).then(setNo1MultiAngleImageOriginalMask)
    }, [no1MultiAngleImageOriginalMask, no1MultiAngleImageEditedMask, no1MultiAngleImageMaskId])
    // 多视角图2显示图
    const [no2MultiAngleShowValue, setNo2MultiAngleShowValue] = useState([])
    useEffect(() => {
        if (no2MultiAngleImageEditedMask) setNo2MultiAngleShowValue([no2MultiAngleImageEditedMask.foregroundMask])
        else if (no2MultiAngleImageOriginalMask) setNo2MultiAngleShowValue([no2MultiAngleImageOriginalMask.foregroundMask])
        else if (no2MultiAngleImageMaskId) getClothMaskOutput(no2MultiAngleImageMaskId).then(setNo2MultiAngleImageOriginalMask)
    }, [no2MultiAngleImageOriginalMask, no2MultiAngleImageEditedMask, no2MultiAngleImageMaskId])

    return (
        <div className={styles.Container}>
            <Segmented
                block
                options={segmentedItems}
                value={currentInputType}
                onChange={handlerInputTypeChange}
            />
            <div className={styles.Header}>
                <span>鞋子图</span>
            </div>
            <div className={styles.Content}>
                {
                    currentInputType == INPUT_IMAGE_TYPE.SINGLE ?
                        <div className={styles.SingleUploader}>
                            <SingleUploader
                                ref={ref}
                                key="single"
                                value={inputImage}
                                showValue={singleShowValue}
                                source={UPLOAD_SOURCE.SHOES}
                                dragTips="释放鼠标上传鞋子图"
                                uploadText="鞋子图"
                                uploadIcon="uploadShoesIcon.png"
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                                loading={inputImageLoading}
                                setLoading={setInputImageLoading}
                                onChange={handleSingleChange}
                                onMattingOpt={handleMattingOptSingle}
                            />
                        </div> :
                        <div className={`${styles.MultiUploader}`} style={{ flexDirection: "column", height: "auto" }}>
                            <div className={styles.SingleUploader}>
                                <SingleUploader
                                    ref={ref}
                                    key="single"
                                    value={inputImage}
                                    showValue={singleShowValue}
                                    source={UPLOAD_SOURCE.SHOES}
                                    dragTips="释放鼠标上传鞋子图"
                                    uploadText="鞋子图"
                                    uploadIcon="uploadShoesIcon.png"
                                    segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                                    loading={inputImageLoading}
                                    setLoading={setInputImageLoading}
                                    onChange={handleSingleChange}
                                    onMattingOpt={() => handleMattingOptMulti(inputImage)}
                                />
                            </div>
                            <div className={styles.MultiUploader}>
                                <SingleUploader
                                    key="top"
                                    value={no1MultiAngleImage}
                                    showValue={no1MultiAngleShowValue}
                                    source={UPLOAD_SOURCE.SHOES}
                                    dragTips="释放鼠标上传辅助图1"
                                    uploadText="辅助图1"
                                    uploadIcon="uploadShoesIcon.png"
                                    paddingInline={39}
                                    segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                                    loading={no1MultiAngleImageLoading}
                                    setLoading={setNo1MultiAngleImageLoading}
                                    onChange={handleFirstChange}
                                    onMattingOpt={() => handleMattingOptMulti(no1MultiAngleImage)}
                                />
                                <SingleUploader
                                    key="bottom"
                                    value={no2MultiAngleImage}
                                    showValue={no2MultiAngleShowValue}
                                    source={UPLOAD_SOURCE.SHOES}
                                    dragTips="释放鼠标上传辅助图2"
                                    uploadText="辅助图2"
                                    uploadIcon="uploadShoesIcon.svg"
                                    paddingInline={39}
                                    segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                                    loading={no2MultiAngleImageLoading}
                                    setLoading={setNo2MultiAngleImageLoading}
                                    onChange={handleSecondChange}
                                    onMattingOpt={() => handleMattingOptMulti(no2MultiAngleImage)}
                                />
                            </div>
                        </div>
                }
            </div>
        </div>
    )
})
const ModelUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        setInputImageColorMaskId,
        setResourceFilter,

        getClothMaskOutput,
        getInteractiveNpyId,
        getModelRecommendFilter,
        getModelColorMaskId,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 模特图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        setInputImageMaskId(res.clothMaskId)
        setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
        // 模型推荐筛选条件
        const filter = await getModelRecommendFilter(res.inputImage)
        setResourceFilter(pre => ({ ...pre, ...filter }))
        // 获取模型maskid
        const colorMaskId = await getModelColorMaskId(res.inputImage)
        if (!colorMaskId) return
        setInputImageColorMaskId(colorMaskId)
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        // if (inputImageEditedMask) setSingleShowValue([inputImage, inputImageEditedMask.foregroundAlphaMask])
        // else if (inputImageOriginalMask) setSingleShowValue([inputImage, inputImageOriginalMask.foregroundAlphaMask])
        if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
        if (inputImage) setSingleShowValue([inputImage])
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId, inputImage])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>模特图</span>
            </div>
            <div className={styles.Content}>
                <div className={`${styles.SingleUploader} ${props.flashBorder ? styles.FlashBorder : ''}`}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true}
                        key="single"
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.MODEL}
                        dragTips="释放鼠标上传模特图"
                        uploadText="模特图"
                        uploadIcon="uploadModelIcon.png"
                        // segmentAlgoType={SEGMENT_ALGO_TYPE.AIMODEL_MASK} // 换换模特去掉四类分割
                        segmentAlgoType={null}
                        mattingOptDisabled={true}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        onMattingOpt={handleMattingOpt}
                        imageType={IMAGE_TYPE.MODEL || IMAGE_TYPE.BACKGROUND}
                    />
                </div>
            </div>
        </div>
    )
})
const BackgroundUploader  = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        setInputImageColorMaskId,
        setResourceFilter,

        getClothMaskOutput,
        getInteractiveNpyId,
        getModelRecommendFilter,
        getModelColorMaskId,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 模特图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
        // 模型推荐筛选条件
        const filter = await getModelRecommendFilter(res.inputImage)
        setResourceFilter(pre => ({ ...pre, ...filter }))
        // 获取模型maskid
        const colorMaskId = await getModelColorMaskId(res.inputImage)
        if (!colorMaskId) return
        setInputImageColorMaskId(colorMaskId)
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImage, inputImageEditedMask.foregroundAlphaMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImage, inputImageOriginalMask.foregroundAlphaMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId, inputImage])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>模特图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true}
                        key="single"
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.MODEL}
                        dragTips="释放鼠标上传模特图"
                        uploadText="模特图"
                        uploadIcon="uploadModelIcon.png"
                        segmentAlgoType={SEGMENT_ALGO_TYPE.AIMODEL_MASK}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        onMattingOpt={handleMattingOpt}
                        imageType={IMAGE_TYPE.MODEL || IMAGE_TYPE.BACKGROUND}
                    />
                </div>
            </div>
        </div>
    )
})
const TryonVideoUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setInputImageMaskId,
        setInputImageOriginalMask,
        setInputImageEditedMask,

        inputImageLoading, setInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
    } = useContext(GenerateContext)

    // 模特视频上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
    }

    const content = (
        <div className={styles.TryonVideoUploaderContent}>
            <div className={styles.TryonVideoUploaderContentImg}></div>
            <p>单人清晰半身/全身图，人物比例建议与视频一致</p>
        </div>
    )

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>模特图
                    <Popover placement="topLeft" title={'模特图'} content={content}>
                        <Iconfont className={styles.Icon} type="icon-qa2" />
                    </Popover>
                </span>

            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        figureCheck={true} // 公众人物检测
                        ref={ref}
                        key="single"
                        value={inputImage}
                        showValue={[inputImage]}
                        source={UPLOAD_SOURCE.TRYON_VIDEO}
                        dragTips="释放鼠标上传模特图"
                        uploadText="模特图"
                        uploadIcon="uploadModelIcon.png"
                        mattingOptDisabled
                        // videoTryonImageDetection
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        imageType={IMAGE_TYPE.MODEL_VIDEO}
                    />
                </div>
            </div>
        </div>
    )
})
const TryonVideoImgUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setInputImageMaskId,
        setInputImageOriginalMask,
        setInputImageEditedMask,

        no1MultiAngleImage, setNo1MultiAngleImage,
        no1MultiAngleImageWidth, setNo1MultiAngleImageWidth,
        no1MultiAngleImageHeight, setNo1MultiAngleImageHeight,
        no1MultiAngleImageMaskId, setNo1MultiAngleImageMaskId,
        no1MultiAngleImageOriginalMask, setNo1MultiAngleImageOriginalMask,
        no1MultiAngleImageEditedMask, setNo1MultiAngleImageEditedMask,
        no1MultiAngleImageNpyId, setNo1MultiAngleImageNpyId,



        inputImageLoading, setInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
    } = useContext(GenerateContext)

    // 模特视频上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
    }
    // 尾帧图上传
    const handleSecondChange = async (res) => {
        if (res.inputImage) setNo1MultiAngleImage(res.inputImage)
        if (res.inputImageWidth) setNo1MultiAngleImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setNo1MultiAngleImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setNo1MultiAngleImageMaskId(res.clothMaskId)
        if (res.originalMask) setNo1MultiAngleImageOriginalMask(res.originalMask)
        setNo1MultiAngleImageEditedMask()
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>模特图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.MultiUploader}>
                    <SingleUploader
                        figureCheck={true} // 公众人物检测
                        ref={ref}
                        key="single"
                        value={inputImage}
                        showValue={[inputImage]}
                        source={UPLOAD_SOURCE.TRYON_VIDEO}
                        dragTips="释放鼠标上传模特图"
                        uploadText="首帧图"
                        uploadIcon="uploadModelIcon.png"
                        mattingOptDisabled
                        // videoTryonImageDetection
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        imageType={IMAGE_TYPE.IMAGE_TO_VIDEO}
                    />
                    <SingleUploader
                        figureCheck={true}
                        // ref={ref}
                        key="single2"
                        value={no1MultiAngleImage}
                        showValue={[no1MultiAngleImage]}
                        source={UPLOAD_SOURCE.TRYON_VIDEO}
                        dragTips="释放鼠标上传模特图"
                        uploadText="尾帧图（可选）"
                        uploadIcon="uploadModelIcon.png"
                        mattingOptDisabled
                        // videoTryonImageDetection
                        loading={no1MultiAngleImageLoading}
                        setLoading={setNo1MultiAngleImageLoading}
                        onChange={handleSecondChange}
                        imageType={IMAGE_TYPE.IMAGE_TO_VIDEO}
                        showDeleteBtn={true}
                        onDelete={() => {
                            setNo1MultiAngleImage('')
                        }}
                    />
                </div>
            </div>
        </div>
    )
})
const CommodityUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setInputImageMaskId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,
        inputImageNpyId, setInputImageNpyId,
        setResourceFilter,

        // 商品自定义场景配置
        refImgConfig,
        // 商品自定义场景强度
        refImgStrength,
        // 商品图输出比例
        outputRatio, setOutputRatio,
        // 商品图输出宽度
        outputWidth, setOutputWidth,
        // 商品图输出高度
        outputHeight, setOutputHeight,
        // 一组元素的位置、缩放、尺寸、旋转等信息
        inputImageTransform, setInputImageTransform,

        getClothMaskOutput,
        getInteractiveNpyId,
        getCommodityRecommendFilter,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 商品图上传
    const handleChange = async (res) => {
        setProjectId()
        const image = res.inputImage
        setInputImageEditedMask()
        setInputImageTransform()
        setInputImageNpyId()
        // 商品输入图
        if (res.originalMask) {
            setInputImageOriginalMask(res.originalMask)
            const output = res.originalMask
            if (res.isPerson) {
                const binaryMask = output.binaryMask
                const [url1, url2, url3] = await Promise.all([
                    getMask1ByMask3(binaryMask), // 通过mask3产出mask1
                    getMask2ByMask3(image, binaryMask), // 通过mask3产出mask2
                    getTrimmedImageOfWhiteBlack(binaryMask), // 处理mask3
                ])
                setInputImageOriginalMask({
                    foregroundAlphaMask: url1,
                    foregroundMask: url2,
                    trimmedMask: url3.url,
                    binaryMask,
                })
            } else {
                setInputImageOriginalMask(output)
            }
            if (res.inputImage) setInputImage(res.inputImage)
            if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
            if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
            if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
            // 获取商品推荐筛选条件
            const filter = await getCommodityRecommendFilter(image, output.binaryMask)
            if (!filter) return
            setResourceFilter(pre => ({
                ...pre,
                recommendCommodityType: filter,
            }))
        }
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask.binaryMask
            foregroundAlphaMask = inputImageOriginalMask.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], async resList => {
            const res = resList[0]
            if (!res) return

            const trimmedRes = await Utils.getTrimmedSizeByBlackMask(res.binaryMask) // 处理mask3
            const { leftTop, rightBottom } = trimmedRes
            const [url1, url2] = await Promise.all([
                Utils.getTrimmedImageBySize(res.binaryMask, leftTop.x, leftTop.y, rightBottom.x, rightBottom.y).then(base64 => Utils.uploadBase64Image(base64, false)),
                Utils.getTrimmedImageBySize(res.foregroundMask, leftTop.x, leftTop.y, rightBottom.x, rightBottom.y).then(base64 => Utils.uploadBase64Image(base64, false)),
            ])
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: url2,
                trimmedMask: url1
            })

            // 重新根据mask获取商品分类
            const filter = await getCommodityRecommendFilter(inputImage, res.binaryMask)
            if (!filter) return
            setResourceFilter(pre => ({
                ...pre,
                recommendCommodityType: filter,
            }))
        })
    }

    // 商品图位置优化
    const [positionOptOpen, setPositionOptOpen] = useState(false)
    const handlePositionOpt = (res) => {
        setPositionOptOpen(true)
    }

    // 通过mask3获取同商品分割一样的mask1
    async function getMask1ByMask3(mask3) {
        const base64 = await Utils.convertWhiteImageToBlue(mask3)
        const url = await Utils.uploadBase64Image(base64, true)
        return url
    }
    async function getTrimmedImageByFrontImage(base64) {
        const res = await Utils.getTrimmedImageBase64(base64)
        const url = await Utils.uploadBase64Image(res.base64, true)
        return url
    }
    async function getMask2ByMask3(origin, mask3) {
        const base64 = await Utils.getFrontImage(origin, mask3)
        return await getTrimmedImageByFrontImage(base64)
    }
    async function getTrimmedImageOfWhiteBlack(url) {
        const res = await Utils.getTrimmedSizeByBlackMask(url)
        const { leftTop, rightBottom } = res
        const base64 = await Utils.getTrimmedImageBySize(url, leftTop.x, leftTop.y, rightBottom.x, rightBottom.y)
        return {
            leftTop,
            rightBottom,
            url: await Utils.uploadBase64Image(base64, false)
        }
    }

    // 商品图输出比例
    const aspectRatio = useMemo(() => {
        if (outputRatio == RESOLUTION_RATIO.CUSTOM) {
            return `${outputWidth} / ${outputHeight}`
        } else {
            switch (outputRatio) {
                case RESOLUTION_RATIO.SQUARE:
                    return "1 / 1"
                case RESOLUTION_RATIO.THREE_FOUR:
                    return "3 / 4"
                case RESOLUTION_RATIO.FOUR_THREE:
                    return "4 / 3"
                case RESOLUTION_RATIO.NINE_SIXTEEN:
                    return "9 / 16"
                case RESOLUTION_RATIO.SIXTEEN_NINE:
                    return "16 / 9"
                default:
                    return "1 / 1"
            }
        }
    }, [outputRatio, outputWidth, outputHeight])
    const direction = useMemo(() => {
        if (outputRatio == RESOLUTION_RATIO.CUSTOM) {
            return outputWidth > outputHeight ? "horizontal" : "vertical"
        } else {
            switch (outputRatio) {
                case RESOLUTION_RATIO.SQUARE:
                    return "horizontal"
                case RESOLUTION_RATIO.THREE_FOUR:
                    return "vertical"
                case RESOLUTION_RATIO.FOUR_THREE:
                    return "horizontal"
                case RESOLUTION_RATIO.NINE_SIXTEEN:
                    return "vertical"
                case RESOLUTION_RATIO.SIXTEEN_NINE:
                    return "horizontal"
                default:
                    return "horizontal"
            }
        }
    }, [outputRatio, outputWidth, outputHeight])

    // 工作台的尺寸
    const [deskWidth, setDeskWidth] = useState(0)
    const [deskHeight, setDeskHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setDeskWidth(entry.contentRect.width - 2)
            setDeskHeight(entry.contentRect.height - 2)
        }
    })

    // 商品图位置优化参数，包括位置和mask
    const positionOptValue = useMemo(() => {
        const { refImgMode } = refImgConfig ?? {}
        const maskUrl = (inputImageEditedMask || inputImageOriginalMask)?.foregroundMask
        const dragScale = inputImageTransform ? [inputImageTransform] : []
        const isCustomScene = !!refImgConfig
        const refImgLocalInfo = refImgMode == COMMODITY_SCENE_MODE.SAME_STYLE ? refImgConfig?.refImgLocalInfo : null
        // const bgImage = refImgMode == COMMODITY_SCE-NE_MODE.SAME_STYLE ? refImgConfig?.refImgProcessed : null
        const bgImage = null // 移除上传框背景显示
        return {
            deskSize: {
                width: deskWidth,
                height: deskHeight,
            },
            imgWidth: outputWidth,
            imgHeight: outputHeight,
            maskUrl: maskUrl,
            dragScale: dragScale,
            isCustomScene: isCustomScene, // 自定义场景
            refImgLocalInfo: refImgLocalInfo, // 自定义场景信息
            bgImage: bgImage, // 背景图
        }
    }, [
        inputImageTransform,
        inputImageOriginalMask,
        inputImageEditedMask,
        outputWidth,
        outputHeight,
        deskWidth,
        deskHeight,
        refImgConfig,
    ])
    // 商品图位置优化
    const dragRef = useRef(null)
    const handleDragChange = (res) => {
        setInputImageTransform(res?.[0])
    }
    const handleDragConfirm = () => {
        const res = dragRef.current?.getDragScale()
        setInputImageTransform(res?.[0])
        setPositionOptOpen(false)
    }

    return (
        <>
            <div className={styles.Container}>
                <div className={styles.Header}>
                    <span>商品图</span>
                </div>
                <div className={`${styles.Content} ${styles.commodityContent}`}>
                    <div ref={targetRef}
                        className={styles.SingleUploader}
                        style={{
                            aspectRatio: aspectRatio,
                            width: direction == "horizontal" ? "100%" : "auto",
                            height: direction == "vertical" ? "100%" : "auto",
                        }}>
                        <SingleUploader
                            ref={ref}
                            key="single"
                            value={inputImage}
                            source={UPLOAD_SOURCE.COMMODITY}
                            dragTips="释放鼠标上传商品图"
                            uploadText="商品图"
                            uploadIcon="uploadCommidityIcon.png"
                            segmentAlgoType={SEGMENT_ALGO_TYPE.AIGOODS_MASK}
                            personDetection={true}
                            segmentAlgoTypeWhenPersonExist={SEGMENT_ALGO_TYPE.AIMODEL_BODY_MASK}
                            imageRatioDetection={true}
                            positionOptDisabled={false}
                            positionOptValue={positionOptValue}
                            loading={inputImageLoading}
                            setLoading={setInputImageLoading}
                            onChange={handleChange}
                            onMattingOpt={handleMattingOpt}
                            onPositionOpt={handlePositionOpt}
                            onPositionChange={handleDragChange}
                        />
                    </div>
                </div>
            </div>
            <PSAIModal
                title="位置优化"
                open={positionOptOpen}
                maskClosable={false}
                closable={false}
                maxWidth={800}
                onCancel={() => setPositionOptOpen(false)}
                onOk={handleDragConfirm}
            >
                <CommodityDragContainer
                    ref={dragRef}
                    positionOptValue={positionOptValue}
                    onDragChange={handleDragChange}
                />
            </PSAIModal>
        </>
    )
})
const CommodityRecolorUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageMultiSemanticId, setInputImageMultiSemanticId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        setInputImageColorMaskId,
        setResourceFilter,

        getClothMaskOutput,
        getInteractiveNpyId,
        getModelRecommendFilter,
        getModelColorMaskId,
        getMultiSemanticId,

        inputImageLoading, setInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
    } = useContext(GenerateContext)

    // 商品图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        if (res.isPerson) {
            // 获取多语义id，人像时直接取clothMaskId，内部走的多语义
            // 某些情况下，clothMaskId可能为鞋子分割id，需要判断下算法类型
            const ids = res.clothMaskId.split(":")
            const algoType = ids[0]
            const algoId = ids.length == 1 ? ids[0] : ids[1]
            if (algoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK) {
                setInputImageMultiSemanticId(algoId)
            } else {
                setInputImageMultiSemanticId(null)
            }
        } else {
            setInputImageMultiSemanticId(null)
        }
        setInputImageEditedMask()
        setInputImageNpyId()
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
            inputImageMultiSemanticId
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImage, inputImageEditedMask.foregroundAlphaMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImage, inputImageOriginalMask.foregroundAlphaMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId, inputImage])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>商品图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader} style={{ height: 376 }}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true} // 公众人物检测
                        key="single"
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.COMMODITY}
                        dragTips="释放鼠标上传商品图"
                        uploadText="商品图"
                        uploadIcon="uploadCommidityIcon.png"
                        segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                        personDetection
                        segmentAlgoTypeWhenPersonExist={SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        onMattingOpt={handleMattingOpt}
                    />
                </div>
            </div>
        </div>
    )
})
const ClothRecolorUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageMultiSemanticId, setInputImageMultiSemanticId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        getClothMaskOutput,
        getInteractiveNpyId,

        inputImageLoading, setInputImageLoading,
        currentClothColorType, setCurrentClothColorType,
        clothReColorIsPerson, setClothReColorIsPerson,
    } = useContext(GenerateContext)

    // 商品图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        if (res.isPerson) {
            setClothReColorIsPerson(true)
            // 获取多语义id，人像时直接取clothMaskId，内部走的多语义
            // 某些情况下，clothMaskId可能为鞋子分割id，需要判断下算法类型
            const ids = res.clothMaskId.split(":")
            const algoType = ids[0]
            const algoId = ids.length == 1 ? ids[0] : ids[1]
            if (algoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK) {
                setInputImageMultiSemanticId(algoId)
            } else {
                setInputImageMultiSemanticId(null)
            }
        } else {
            setClothReColorIsPerson(false)
            setInputImageMultiSemanticId(null)
        }
        setInputImageEditedMask()
        setInputImageNpyId()
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
            inputImageMultiSemanticId
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImage, inputImageEditedMask.foregroundAlphaMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImage, inputImageOriginalMask.foregroundAlphaMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId, inputImage])

    return (
        <div className={styles.Container}>
            <div className={styles.Header} style={{ marginTop: -25 }}>
                <span>模特图/服饰图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true} // 公众人物检测
                        key={CLOTH_COLOR_TYPE.CLOTH_RECOLOR}
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.COMMODITY}
                        dragTips="释放鼠标上传商品图"
                        uploadText="模特图/服饰图"
                        uploadIcon="uploadModelIcon.png"
                        segmentAlgoType={SEGMENT_ALGO_TYPE.AISHOES_MASK}
                        personDetection
                        segmentAlgoTypeWhenPersonExist={SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        onMattingOpt={handleMattingOpt}
                    />
                </div>
            </div>
        </div>
    )
})
const ClothRecolorUploaderSim = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,

        setInputImageColorMaskId,
        setResourceFilter,

        getClothMaskOutput,
        getInteractiveNpyId,
        getModelColorMaskId,
        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 模特图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
        // 获取模型maskid
        const colorMaskId = await getModelColorMaskId(res.inputImage)
        if (!colorMaskId) return
        setInputImageColorMaskId(colorMaskId)
    }

    // 抠图优化
    const handleMattingOpt = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImage, inputImageEditedMask.foregroundAlphaMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImage])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId, inputImage])

    return (
        <div className={styles.Container}>
            <div className={styles.Header} style={{ marginTop: -25 }}>
                <span>模特图</span>
            </div>
            <div className={styles.Content}
                onClick={() => {
                    const status = Utils.checkLoginStatus(() => null)
                    if (status) {
                        props.globalOrgInfo?.isPersonal && props.setChangeUserOpen(true)
                    }
                }}>
                <div className={styles.SingleUploader} style={{ pointerEvents: props.globalOrgInfo?.isPersonal || !props.globalOrgInfo ? 'none' : 'auto' }}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true}
                        key="single"
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.MODEL}
                        dragTips="释放鼠标上传模特图"
                        uploadText="模特图"
                        uploadIcon="uploadModelIcon.png"
                        segmentAlgoType={SEGMENT_ALGO_TYPE.AIMODEL_MASK}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        onMattingOpt={handleMattingOpt}
                        imageType={IMAGE_TYPE.MODEL || IMAGE_TYPE.BACKGROUND}
                    />
                </div>
            </div>
        </div>
    )
})
const ClothRecolorUploaderMatch = forwardRef((props, ref) => {
    const {
        setProjectId,
        currentInputType, setCurrentInputType,
        // 输入图
        mainInputImage, setMainInputImage,
        mainInputImageWidth, setMainInputImageWidth,
        mainInputImageHeight, setMainInputImageHeight,
        mainInputImageMaskId, setMainInputImageMaskId,
        mainInputImageOriginalMask, setMainInputImageOriginalMask,
        mainInputImageEditedMask, setMainInputImageEditedMask,
        mainInputImageNpyId, setMainInputImageNpyId,
        mainInputImageClothType, setMainInputImageClothType,

        // 上装
        topInputImage, setTopInputImage,
        topInputImageWidth, setTopInputImageWidth,
        topInputImageHeight, setTopInputImageHeight,
        topInputImageMaskId, setTopInputImageMaskId,
        topInputImageOriginalMask, setTopInputImageOriginalMask,
        topInputImageEditedMask, setTopInputImageEditedMask,
        topInputImageNpyId, setTopInputImageNpyId,
        // 下装
        bottomInputImage, setBottomInputImage,
        bottomInputImageWidth, setBottomInputImageWidth,
        bottomInputImageHeight, setBottomInputImageHeight,
        bottomInputImageMaskId, setBottomInputImageMaskId,
        bottomInputImageOriginalMask, setBottomInputImageOriginalMask,
        bottomInputImageEditedMask, setBottomInputImageEditedMask,
        bottomInputImageNpyId, setBottomInputImageNpyId,
        getClothMaskOutput,
        getInteractiveNpyId,

        mainInputImageLoading, setMainInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
    } = useContext(GenerateContext)

    // 单图上传
    const handleSingleChange = async (res) => {
        // setProjectId()
        if (res.inputImage) setMainInputImage(res.inputImage)
        if (res.inputImageWidth) setMainInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setMainInputImageHeight(res.inputImageHeight)
        if (res.clothType) setMainInputImageClothType(res.clothType)
        if (res.clothMaskId) setMainInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setMainInputImageOriginalMask(res.originalMask)
        setMainInputImageEditedMask()
        setMainInputImageNpyId()
    }
    // 上装
    const handleTopChange = async (res) => {
        // setProjectId()
        let matchClothType = res.clothType
        let matchClothTypeCN = "未知"
        let inputClothTypeCN = ""
        let clothTypeRequire = TRYON_CLOTH_TYPE.TOP
        let clothTypeRequireCN = "上装"
        if (matchClothType == TRYON_CLOTH_TYPE.TOP) {
            matchClothTypeCN = "上装"
            inputClothTypeCN = "上装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.BOTTOM) {
            matchClothTypeCN = "下装"
            inputClothTypeCN = "下装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.DRESS) {
            matchClothTypeCN = "连体装"
            inputClothTypeCN = "下装"
        }
        if (matchClothType != clothTypeRequire) {
            PSAIModal.confirm({
                headTitle: "图片填充",
                content: (
                    <div className={styles.InputImageUploaderModalContent}>
                        <img src={res.inputImage} style={{ width: 128, height: 128 }} />
                        <div>
                            <span>{`算法检测到您上传的图片可能为${matchClothTypeCN}`}</span>
                            <span>{`是否作为${inputClothTypeCN}填入`}</span>
                        </div>
                    </div>
                ),
                okText: `是${inputClothTypeCN}，帮我填入`,
                cancelText: `是${clothTypeRequireCN}`,
                onOk() {
                    if (res.inputImage) setBottomInputImage(res.inputImage)
                    if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
                    setBottomInputImageEditedMask()
                    setBottomInputImageNpyId()
                },
                onCancel() {
                    if (res.inputImage) setTopInputImage(res.inputImage)
                    if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
                    setTopInputImageEditedMask()
                    setTopInputImageNpyId()
                },
                onClose: () => { }
            })
        } else {
            if (res.inputImage) setTopInputImage(res.inputImage)
            if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
            if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
            if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
            if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
            setTopInputImageEditedMask()
            setTopInputImageNpyId()
        }
    }
    // 下装
    const handleBottomChange = async (res) => {
        // setProjectId()
        let matchClothType = res.clothType
        let matchClothTypeCN = "未知"
        let inputClothTypeCN = ""
        let clothTypeRequire = TRYON_CLOTH_TYPE.BOTTOM
        let clothTypeRequireCN = "下装"
        if (matchClothType == TRYON_CLOTH_TYPE.TOP) {
            matchClothTypeCN = "上装"
            inputClothTypeCN = "上装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.BOTTOM) {
            matchClothTypeCN = "下装"
            inputClothTypeCN = "下装"
        } else if (matchClothType == TRYON_CLOTH_TYPE.DRESS) {
            matchClothTypeCN = "连体装"
            inputClothTypeCN = "上装"
        }
        if (matchClothType != clothTypeRequire) {
            PSAIModal.confirm({
                headTitle: "图片填充",
                content: (
                    <div className={styles.InputImageUploaderModalContent}>
                        <img src={res.inputImage} style={{ width: 128, height: 128 }} />
                        <div>
                            <span>{`算法检测到您上传的图片可能为${matchClothTypeCN}`}</span>
                            <span>{`是否作为${inputClothTypeCN}填入`}</span>
                        </div>
                    </div>
                ),
                okText: `是${inputClothTypeCN}，帮我填入`,
                cancelText: `是${clothTypeRequireCN}`,
                onOk() {
                    if (res.inputImage) setTopInputImage(res.inputImage)
                    if (res.inputImageWidth) setTopInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setTopInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setTopInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setTopInputImageOriginalMask(res.originalMask)
                    setTopInputImageEditedMask()
                    setTopInputImageNpyId()
                },
                onCancel() {
                    if (res.inputImage) setBottomInputImage(res.inputImage)
                    if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
                    if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
                    if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
                    if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
                    setBottomInputImageEditedMask()
                    setBottomInputImageNpyId()
                },
                onClose: () => { }
            })
        } else {
            if (res.inputImage) setBottomInputImage(res.inputImage)
            if (res.inputImageWidth) setBottomInputImageWidth(res.inputImageWidth)
            if (res.inputImageHeight) setBottomInputImageHeight(res.inputImageHeight)
            if (res.clothMaskId) setBottomInputImageMaskId(res.clothMaskId)
            if (res.originalMask) setBottomInputImageOriginalMask(res.originalMask)
            setBottomInputImageEditedMask()
            setBottomInputImageNpyId()
        }
    }
    // 单件服装/上下搭配
    const segmentedItems = [{
        label: "单件换色",
        value: INPUT_IMAGE_TYPE.SINGLE,
    }, {
        label: "套装换色",
        value: INPUT_IMAGE_TYPE.MULTI,
    }]
    // 单件服装/上下搭配切换时，输入图相互带入
    const handlerInputTypeChange = value => {
        // setProjectId()
        if (value == INPUT_IMAGE_TYPE.SINGLE) { // 单件服装
            if (topInputImage) {
                setMainInputImage(topInputImage)
                setMainInputImageWidth(topInputImageWidth)
                setMainInputImageHeight(topInputImageHeight)
                setMainInputImageMaskId(topInputImageMaskId)
                setMainInputImageOriginalMask(topInputImageOriginalMask)
                setMainInputImageEditedMask(topInputImageEditedMask)
                setMainInputImageNpyId(topInputImageNpyId)
                setMainInputImageClothType(TRYON_CLOTH_TYPE.TOP)
            } else if (bottomInputImage) {
                setMainInputImage(bottomInputImage)
                setMainInputImageWidth(bottomInputImageWidth)
                setMainInputImageHeight(bottomInputImageHeight)
                setMainInputImageMaskId(bottomInputImageMaskId)
                setMainInputImageOriginalMask(bottomInputImageOriginalMask)
                setMainInputImageEditedMask(bottomInputImageEditedMask)
                setMainInputImageNpyId(bottomInputImageNpyId)
                setMainInputImageClothType(TRYON_CLOTH_TYPE.BOTTOM)
            }
            setTopInputImage()
            setTopInputImageWidth()
            setTopInputImageHeight()
            setTopInputImageMaskId()
            setTopInputImageOriginalMask()
            setTopInputImageEditedMask()
            setTopInputImageNpyId()
            setBottomInputImage()
            setBottomInputImageWidth()
            setBottomInputImageHeight()
            setBottomInputImageMaskId()
            setBottomInputImageOriginalMask()
            setBottomInputImageEditedMask()
            setBottomInputImageNpyId()
        } else if (value == INPUT_IMAGE_TYPE.MULTI) { // 上下搭配
            if (mainInputImage) {
                if (mainInputImageClothType == TRYON_CLOTH_TYPE.TOP) {
                    setTopInputImage(mainInputImage)
                    setTopInputImageWidth(mainInputImageWidth)
                    setTopInputImageHeight(mainInputImageHeight)
                    setTopInputImageMaskId(mainInputImageMaskId)
                    setTopInputImageOriginalMask(mainInputImageOriginalMask)
                    setTopInputImageEditedMask(mainInputImageEditedMask)
                    setTopInputImageNpyId(mainInputImageNpyId)
                } else if (mainInputImageClothType == TRYON_CLOTH_TYPE.BOTTOM) {
                    setBottomInputImage(mainInputImage)
                    setBottomInputImageWidth(mainInputImageWidth)
                    setBottomInputImageHeight(mainInputImageHeight)
                    setBottomInputImageMaskId(mainInputImageMaskId)
                    setBottomInputImageOriginalMask(mainInputImageOriginalMask)
                    setBottomInputImageEditedMask(mainInputImageEditedMask)
                    setBottomInputImageNpyId(mainInputImageNpyId)
                } else if (mainInputImageClothType == TRYON_CLOTH_TYPE.DRESS) {
                    setTopInputImage(mainInputImage)
                    setTopInputImageWidth(mainInputImageWidth)
                    setTopInputImageHeight(mainInputImageHeight)
                    setTopInputImageMaskId(mainInputImageMaskId)
                    setTopInputImageOriginalMask(mainInputImageOriginalMask)
                    setTopInputImageEditedMask(mainInputImageEditedMask)
                    setTopInputImageNpyId(mainInputImageNpyId)
                }
                setMainInputImage()
                setMainInputImageWidth()
                setMainInputImageHeight()
                setMainInputImageMaskId()
                setMainInputImageOriginalMask()
                setMainInputImageEditedMask()
                setMainInputImageNpyId()
                setMainInputImageClothType()
            }
        }
        setCurrentInputType(value)
    }
    // 抠图优化
    const handleMattingOptSingle = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (mainInputImageEditedMask) {
            binaryMask = mainInputImageEditedMask.binaryMask
            foregroundAlphaMask = mainInputImageEditedMask.foregroundAlphaMask
            foregroundMask = mainInputImageEditedMask.foregroundMask
        } else {
            binaryMask = mainInputImageOriginalMask?.binaryMask
            foregroundAlphaMask = mainInputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = mainInputImageOriginalMask?.foregroundMask
        }
        if (mainInputImageNpyId) {
            interactiveNpyId = mainInputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(mainInputImage, binaryMask)
            if (!interactiveNpyId) return
            setMainInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage: mainInputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setMainInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }
    const handleMattingOptMulti = async (key) => {
        const groups = []
        // TRYON_CLOTH_TYPE.TOP
        if (topInputImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (topInputImageEditedMask) {
                binaryMask = topInputImageEditedMask.binaryMask
                foregroundAlphaMask = topInputImageEditedMask.foregroundAlphaMask
                foregroundMask = topInputImageEditedMask.foregroundMask
            } else {
                binaryMask = topInputImageOriginalMask?.binaryMask
                foregroundAlphaMask = topInputImageOriginalMask?.foregroundAlphaMask
                foregroundMask = topInputImageOriginalMask?.foregroundMask
            }
            if (topInputImageNpyId) {
                interactiveNpyId = topInputImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(topInputImage, binaryMask)
                if (!interactiveNpyId) return
                setTopInputImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: topInputImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        // TRYON_CLOTH_TYPE.BOTTOM
        if (bottomInputImage) {
            let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
            if (bottomInputImageEditedMask) {
                binaryMask = bottomInputImageEditedMask.binaryMask
                foregroundAlphaMask = bottomInputImageEditedMask.foregroundAlphaMask
                foregroundMask = bottomInputImageEditedMask.foregroundMask
            } else {
                binaryMask = bottomInputImageOriginalMask?.binaryMask
                foregroundAlphaMask = bottomInputImageOriginalMask?.foregroundAlphaMask
                foregroundMask = bottomInputImageOriginalMask?.foregroundMask
            }
            if (bottomInputImageNpyId) {
                interactiveNpyId = bottomInputImageNpyId
            } else {
                interactiveNpyId = await getInteractiveNpyId(bottomInputImage, binaryMask)
                if (!interactiveNpyId) return
                setBottomInputImageNpyId(interactiveNpyId)
            }
            groups.push({
                inputImage: bottomInputImage,
                binaryMask,
                foregroundAlphaMask,
                foregroundMask,
                interactiveNpyId,
            })
        }
        const current = groups.findIndex(item => item.inputImage == key)
        // 发起抠图优化
        props.onMattingOpt(current, groups, resList => {
            for (let i = 0; i < resList.length; i++) {
                const res = resList[i]
                if (!res) continue
                if (i == 0) {
                    setTopInputImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                } else if (i == 1) {
                    setBottomInputImageEditedMask({
                        binaryMask: res.binaryMask,
                        foregroundAlphaMask: res.foregroundAlphaMask,
                        foregroundMask: res.foregroundMask,
                    })
                }
            }
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (mainInputImageEditedMask) setSingleShowValue([mainInputImageEditedMask.foregroundMask])
        else if (mainInputImageOriginalMask) setSingleShowValue([mainInputImageOriginalMask.foregroundMask])
        else if (mainInputImageMaskId) getClothMaskOutput(mainInputImageMaskId).then(setMainInputImageOriginalMask)
    }, [mainInputImageOriginalMask, mainInputImageEditedMask, mainInputImageMaskId])
    // 上装显示图
    const [topShowValue, setTopShowValue] = useState([])
    useEffect(() => {
        if (topInputImageEditedMask) setTopShowValue([topInputImageEditedMask.foregroundMask])
        else if (topInputImageOriginalMask) setTopShowValue([topInputImageOriginalMask.foregroundMask])
        else if (topInputImageMaskId) getClothMaskOutput(topInputImageMaskId).then(setTopInputImageOriginalMask)
    }, [topInputImageOriginalMask, topInputImageEditedMask, topInputImageMaskId])
    // 下装显示图
    const [bottomShowValue, setBottomShowValue] = useState([])
    useEffect(() => {
        if (bottomInputImageEditedMask) setBottomShowValue([bottomInputImageEditedMask.foregroundMask])
        else if (bottomInputImageOriginalMask) setBottomShowValue([bottomInputImageOriginalMask.foregroundMask])
        else if (bottomInputImageMaskId) getClothMaskOutput(bottomInputImageMaskId).then(setBottomInputImageOriginalMask)
    }, [bottomInputImageOriginalMask, bottomInputImageEditedMask, bottomInputImageMaskId])

    return (
        <div className={styles.Container}>
            {/* <Segmented
                block
                options={segmentedItems}
                value={currentInputType}
                onChange={handlerInputTypeChange}
            /> */}
            <div style={{ display: 'flex', gap: '4px' }}>
                {segmentedItems.map(item => (
                    <Button
                        key={item.value}
                        style={{ width: '96px', height: '32px' }}
                        block
                        type={currentInputType === item.value ? 'primary' : 'default'}
                        onClick={() => handlerInputTypeChange(item.value)}
                    >
                        {item.label}
                    </Button>
                ))}
            </div>

            <div className={styles.Header}>
                <span>衣服平铺图<span style={{ color: '#96A2B1' }}>（需上传同款不同色）</span></span>
            </div>
            <div className={styles.Content}
                onClick={() => {
                    const status = Utils.checkLoginStatus(() => null)
                    if (status) {
                        props.globalOrgInfo?.isPersonal && props.setChangeUserOpen(true)
                    }
                }}>
                {
                    currentInputType == INPUT_IMAGE_TYPE.SINGLE ?
                        <div className={styles.SingleUploader} style={{ pointerEvents: props.globalOrgInfo?.isPersonal || !props.globalOrgInfo ? 'none' : 'auto' }}>
                            <SingleUploader
                                key="single"
                                value={mainInputImage}
                                showValue={singleShowValue}
                                clothType={mainInputImageClothType}
                                showClothType
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_DRESS}
                                dragTips="释放鼠标添加服装"
                                uploadText="衣服平铺图"
                                uploadIcon="uploadClothIcon.png"
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={mainInputImageLoading}
                                setLoading={setMainInputImageLoading}
                                onChange={handleSingleChange}
                                onMattingOpt={handleMattingOptSingle}
                            />
                        </div> :
                        <div className={styles.MultiUploader} style={{ pointerEvents: props.globalOrgInfo?.isPersonal || !props.globalOrgInfo ? 'none' : 'auto' }}>
                            <SingleUploader
                                key="top"
                                value={topInputImage}
                                showValue={topShowValue}
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_TOP}
                                dragTips="释放鼠标上传上装"
                                uploadText="上装"
                                uploadIcon="uploadClothIcon.png"
                                paddingInline={39}
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={topInputImageLoading}
                                setLoading={setTopInputImageLoading}
                                onChange={handleTopChange}
                                onMattingOpt={() => handleMattingOptMulti(topInputImage)}
                            />
                            <SingleUploader
                                key="bottom"
                                value={bottomInputImage}
                                showValue={bottomShowValue}
                                clothTypeDetection
                                source={UPLOAD_SOURCE.CLOTH_BOTTOM}
                                dragTips="释放鼠标上传下装"
                                uploadText='下装'
                                uploadIcon="uploadClothIcon.png"
                                paddingInline={39}
                                segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                                loading={bottomInputImageLoading}
                                setLoading={setBottomInputImageLoading}
                                onChange={handleBottomChange}
                                onMattingOpt={() => handleMattingOptMulti(bottomInputImage)}
                            />
                        </div>
                }
            </div>
        </div>
    )
})
const PoseTryonUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        imageType,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setResourceFilter,
        getModelRecommendFilter,
        // 姿势裂变模式
        currentPoseFantasyMode, setCurrentPoseFantasyMode,
        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 模特图上传
    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)

        // 模型推荐筛选条件
        let filter = await getModelRecommendFilter(res.inputImage)

        if (!filter) return
        // 姿势裂变筛选转化
        if (imageType == IMAGE_TYPE.POSE_TRYON) {
            filter = {
                ...filter,
                ...(filter.age && filter.age.length > 0 ? {
                    age: filter.age.map(a => a === '青年' ? '成年' : '儿童')
                } : {})
            }
        }
        setResourceFilter(pre => ({ ...pre, ...filter }))
    }



    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {

        if (inputImage) setSingleShowValue([inputImage])
    }, [inputImage])

    const segmentedItems = [{
        label: "参考图模式",
        value: POSE_FANTASY_MODE.REFERENCEMODE,
    }, {
        label: "自由模式",
        value: POSE_FANTASY_MODE.FREEMODE,
    }]

    return (
        <div className={styles.Container}>
            <Segmented
                block
                options={segmentedItems}
                value={currentPoseFantasyMode}
                onChange={setCurrentPoseFantasyMode}
            />
            <div className={styles.Header}>
                <span>模特图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        ref={ref}
                        figureCheck={true} // 公众人物检测
                        key="single"
                        value={inputImage}
                        showValue={singleShowValue}
                        source={UPLOAD_SOURCE.POSE_TRYON}
                        dragTips="释放鼠标上传模特图"
                        uploadText="模特图"
                        uploadIcon="uploadModelIcon.png"
                        segmentAlgoType={SEGMENT_ALGO_TYPE.AIMODEL_MASK}
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        // onMattingOpt={handleMattingOpt}
                        mattingOptDisabled
                    />
                </div>
            </div>
        </div>
    )
})
const GlassesTryonUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageNpyId, setInputImageNpyId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,
        getClothMaskOutput,
        getInteractiveNpyId,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 眼镜图上传
    const handleSingleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
    }
    // 抠图优化
    const handleMattingOptSingle = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }
    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImageEditedMask.foregroundMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImageOriginalMask.foregroundMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>眼镜商品图</span>
            </div>
            <div className={styles.Content}>
                {
                    <div className={styles.SingleUploader}>
                        <SingleUploader
                            ref={ref}
                            key="single"
                            value={inputImage}
                            showValue={singleShowValue}
                            source={UPLOAD_SOURCE.GLASSES_TRYON}
                            dragTips="释放鼠标上传眼镜商品图"
                            uploadText="眼镜图"
                            uploadIcon="uploadGlassesIcon.png"
                            segmentAlgoType={SEGMENT_ALGO_TYPE.AIGLASSES_MASK}
                            loading={inputImageLoading}
                            setLoading={setInputImageLoading}
                            onChange={handleSingleChange}
                            onMattingOpt={handleMattingOptSingle}
                        />
                    </div>
                }
            </div>
        </div>
    )
})
const SimTryonUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        // 输入图
        inputImage, setInputImage,
        // 输入图宽度
        inputImageWidth, setInputImageWidth,
        // 输入图高度
        inputImageHeight, setInputImageHeight,
        inputImageMaskId, setInputImageMaskId,
        inputImageOriginalMask, setInputImageOriginalMask,
        inputImageEditedMask, setInputImageEditedMask,
        inputImageNpyId, setInputImageNpyId,
        inputImageClothType, setInputImageClothType,
        getClothMaskOutput,
        getInteractiveNpyId,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    // 单图上传
    const handleSingleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothType) setInputImageClothType(res.clothType)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
        setInputImageNpyId()
    }

    // 抠图优化
    const handleMattingOptSingle = async () => {
        let binaryMask, foregroundAlphaMask, foregroundMask, interactiveNpyId
        if (inputImageEditedMask) {
            binaryMask = inputImageEditedMask.binaryMask
            foregroundAlphaMask = inputImageEditedMask.foregroundAlphaMask
            foregroundMask = inputImageEditedMask.foregroundMask
        } else {
            binaryMask = inputImageOriginalMask?.binaryMask
            foregroundAlphaMask = inputImageOriginalMask?.foregroundAlphaMask
            foregroundMask = inputImageOriginalMask?.foregroundMask
        }
        if (inputImageNpyId) {
            interactiveNpyId = inputImageNpyId
        } else {
            interactiveNpyId = await getInteractiveNpyId(inputImage, binaryMask)
            if (!interactiveNpyId) return
            setInputImageNpyId(interactiveNpyId)
        }
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            interactiveNpyId,
        }], resList => {
            const res = resList[0]
            if (!res) return
            setInputImageEditedMask({
                binaryMask: res.binaryMask,
                foregroundAlphaMask: res.foregroundAlphaMask,
                foregroundMask: res.foregroundMask,
            })
        })
    }

    // 单图显示图
    const [singleShowValue, setSingleShowValue] = useState([])
    useEffect(() => {
        if (inputImageEditedMask) setSingleShowValue([inputImageEditedMask.foregroundMask])
        else if (inputImageOriginalMask) setSingleShowValue([inputImageOriginalMask.foregroundMask])
        else if (inputImageMaskId) getClothMaskOutput(inputImageMaskId).then(setInputImageOriginalMask)
    }, [inputImageOriginalMask, inputImageEditedMask, inputImageMaskId])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>衣服平铺图</span>
            </div>
            <div className={styles.Content}>
                {
                    <div className={styles.SingleUploader}>
                        <SingleUploader
                            key="single"
                            value={inputImage}
                            showValue={singleShowValue}
                            clothType={inputImageClothType}
                            showClothType
                            clothTypeDetection
                            source={UPLOAD_SOURCE.SIM_TRYON}
                            dragTips="释放鼠标添加服装"
                            uploadText="衣服图"
                            uploadIcon="uploadClothIcon.png"
                            segmentAlgoType={SEGMENT_ALGO_TYPE.AICLOTH_MASK}
                            loading={inputImageLoading}
                            setLoading={setInputImageLoading}
                            onChange={handleSingleChange}
                            onMattingOpt={handleMattingOptSingle}
                        />
                    </div>
                }
            </div>
        </div>
    )
})
const GrassPlantUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setInputImageMaskId,
        setInputImageOriginalMask,
        setInputImageEditedMask,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>模特穿搭图</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        figureCheck={true}
                        ref={ref}
                        key="single"
                        value={inputImage}
                        showValue={[inputImage]}
                        source={UPLOAD_SOURCE.GRASS_PLANT}
                        dragTips="释放鼠标上传种草图"
                        uploadText="种草图"
                        uploadIcon="uploadModelIcon.png"
                        mattingOptDisabled
                        // videoTryonImageDetection
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        imageType={IMAGE_TYPE.GRASS_PLANT}
                    />
                </div>
            </div>
        </div>
    )
})
const WatermarkRemoveUploader = forwardRef((props, ref) => {
    const {
        setProjectId,
        inputImage, setInputImage,
        inputImageWidth, setInputImageWidth,
        inputImageHeight, setInputImageHeight,
        setInputImageMaskId,
        setInputImageOriginalMask,
        setInputImageEditedMask,

        inputImageLoading, setInputImageLoading,
    } = useContext(GenerateContext)

    const handleChange = async (res) => {
        setProjectId()
        if (res.inputImage) setInputImage(res.inputImage)
        if (res.inputImageWidth) setInputImageWidth(res.inputImageWidth)
        if (res.inputImageHeight) setInputImageHeight(res.inputImageHeight)
        if (res.clothMaskId) setInputImageMaskId(res.clothMaskId)
        if (res.originalMask) setInputImageOriginalMask(res.originalMask)
        setInputImageEditedMask()
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>源素材</span>
            </div>
            <div className={styles.Content}>
                <div className={styles.SingleUploader}>
                    <SingleUploader
                        figureCheck={true}
                        ref={ref}
                        key="single"
                        value={inputImage}
                        showValue={[inputImage]}
                        source={UPLOAD_SOURCE.WATERMARK_REMOVE}
                        dragTips="释放鼠标上传水印图"
                        uploadText="源素材"
                        uploadIcon="uploadModelIcon.png"
                        mattingOptDisabled
                        // videoTryonImageDetection
                        loading={inputImageLoading}
                        setLoading={setInputImageLoading}
                        onChange={handleChange}
                        imageType={IMAGE_TYPE.WATERMARK_REMOVE}
                    />
                </div>
            </div>
        </div>
    )
})


const InputImageUploader = (props) => {
    const {
        imageType,
        getMultiSemanticOutput,
        currentClothColorType, setCurrentClothColorType,
        setProjectId, setInputImage, setInputImageWidth, setInputImageHeight,
        setInputImageMaskId, setInputImageOriginalMask, setInputImageEditedMask, setInputImageNpyId,
        setTopInputImage, setTopInputImageWidth, setTopInputImageHeight, setTopInputImageMaskId,
        setTopInputImageOriginalMask, setTopInputImageEditedMask, setTopInputImageNpyId,
        setBottomInputImage, setBottomInputImageWidth, setBottomInputImageHeight, setBottomInputImageMaskId,
        setBottomInputImageOriginalMask, setBottomInputImageEditedMask, setBottomInputImageNpyId,
        setMainInputImage, setMainInputImageWidth, setMainInputImageHeight, setMainInputImageClothType,
        setMainInputImageMaskId, setMainInputImageOriginalMask, setMainInputImageEditedMask, setMainInputImageNpyId,
    } = useContext(GenerateContext)
    const { globalOrgInfo } = useContext(AppContext)
    const uploaderRef = useRef()
    const [mattingOptOpen, setMattingOptOpen] = useState(false)
    const [mattingOptGroups, setMattingOptGroups] = useState([])
    const [mattingOptIndex, setMattingOptIndex] = useState(0)
    const [mattingOptLoading, setMattingOptLoading] = useState(false)
    const [changeUserOpen, setChangeUserOpen] = useState(false)
    const mattingOptRefs = useRef([])
    const mattingOptCallback = useRef(null)

    // 抠图优化
    const handleMattingOpt = (current, groups, callback) => {
        setMattingOptOpen(true)
        setMattingOptGroups(groups)
        setMattingOptIndex(current)
        mattingOptCallback.current = callback
    }
    // 抠图优化保存
    const handleMattingOptSave = async () => {
        setMattingOptLoading(true)
        const resList = []
        for (let ref of mattingOptRefs.current) {
            const changed = await ref.saveHandle();
            if (changed) {
                const { blueMask, whiteMask, blendedImage } = changed;
                const blendedImageUrl = await Utils.uploadBase64Image(blendedImage)
                resList.push({
                    binaryMask: whiteMask,
                    foregroundAlphaMask: blueMask,
                    foregroundMask: blendedImageUrl,
                })
            } else {
                console.log('no change')
                resList.push(null)
            }
        }
        if (mattingOptCallback.current) {
            await mattingOptCallback.current(resList)
            mattingOptCallback.current = null
        }
        setMattingOptLoading(false)
        setMattingOptOpen(false)
    }

    useEffect(() => {
        const sendUrlToInputImage = (url, imageType) => {
            uploaderRef.current?.sendUrlToInputImage?.(url, imageType)
        }
        eventBus.on("sendUrlToInputImage", sendUrlToInputImage)
        return () => {
            eventBus.off("sendUrlToInputImage", sendUrlToInputImage)
        }
    }, [])

    const segmentedItems = [{
        label: "自由换色",
        value: CLOTH_COLOR_TYPE.CLOTH_RECOLOR,
    }, {
        label: <p className={styles.SegmentedItem}>同款换色 <span className={styles.teamIcon}></span></p>,
        value: CLOTH_COLOR_TYPE.SIM_RECOLOR,
    }]

    const handleChangeClothColorType = (value) => {
        setProjectId(null)
        setInputImage()
        setInputImageWidth()
        setInputImageHeight()
        setInputImageMaskId()
        setInputImageOriginalMask()
        setInputImageEditedMask()
        setInputImageNpyId()


        setMainInputImage()
        setMainInputImageWidth()
        setMainInputImageHeight()
        setMainInputImageClothType()
        setMainInputImageMaskId()
        setMainInputImageOriginalMask()
        setMainInputImageEditedMask()
        setMainInputImageNpyId()

        setTopInputImage()
        setTopInputImageWidth()
        setTopInputImageHeight()
        setTopInputImageMaskId()
        setTopInputImageOriginalMask()
        setTopInputImageEditedMask()
        setTopInputImageNpyId()

        setBottomInputImage()
        setBottomInputImageWidth()
        setBottomInputImageHeight()
        setBottomInputImageMaskId()
        setBottomInputImageOriginalMask()
        setBottomInputImageEditedMask()
        setBottomInputImageNpyId()

        setCurrentClothColorType(value)
    }


    return (
        <>
            {
                imageType == IMAGE_TYPE.CLOTHES ? <ClothesUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                    imageType == IMAGE_TYPE.MODEL ? <ModelUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} flashBorder={props.flashModelBorder} /> :
                        imageType == IMAGE_TYPE.BACKGROUND ? <BackgroundUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                            imageType == IMAGE_TYPE.SHOES ? <ShoesUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? <TryonVideoImgUploader ref={uploaderRef} /> :
                                    imageType == IMAGE_TYPE.MODEL_VIDEO ? <TryonVideoUploader ref={uploaderRef} /> :
                                        imageType == IMAGE_TYPE.COMMODITY ? <CommodityUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                            imageType == IMAGE_TYPE.COMMODITYRECOLOR ? <CommodityRecolorUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                                imageType == IMAGE_TYPE.CLOTH_RECOLOR ? <>
                                                    <Segmented
                                                        block
                                                        options={segmentedItems}
                                                        value={currentClothColorType}
                                                        onChange={handleChangeClothColorType}
                                                    />
                                                    {
                                                        currentClothColorType == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ?
                                                            <ClothRecolorUploader setChangeUserOpen={setChangeUserOpen} ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                                            <ClothRecolorUploaderSim globalOrgInfo={globalOrgInfo} setChangeUserOpen={setChangeUserOpen} ref={uploaderRef} onMattingOpt={handleMattingOpt} />
                                                    }

                                                    {currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR && <ClothRecolorUploaderMatch globalOrgInfo={globalOrgInfo} setChangeUserOpen={setChangeUserOpen} ref={uploaderRef} onMattingOpt={handleMattingOpt} />}
                                                </> :
                                                    imageType == IMAGE_TYPE.POSE_TRYON ? <PoseTryonUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                                        imageType == IMAGE_TYPE.GLASSES_TRYON ? <GlassesTryonUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                                            imageType == IMAGE_TYPE.SIM_TRYON ? <SimTryonUploader ref={uploaderRef} onMattingOpt={handleMattingOpt} /> :
                                                                imageType == IMAGE_TYPE.GRASS_PLANT ? <GrassPlantUploader ref={uploaderRef} /> :
                                                                    imageType == IMAGE_TYPE.WATERMARK_REMOVE ? <WatermarkRemoveUploader ref={uploaderRef} /> :
                                                                        null
            }
            <PSAIModal
                title={imageType == IMAGE_TYPE.MODEL ? '编辑保留区域' : '编辑选区'}
                maxWidth={1300}
                closable={false}
                maskClosable={false}
                open={mattingOptOpen}
                confirmLoading={mattingOptLoading}
                okText="保存修改"
                cancelText="放弃修改"
                onCancel={() => setMattingOptOpen(false)}
                onOk={handleMattingOptSave}
            >
                <div className={`${styles.MattingOptList} ${mattingOptGroups.length > 1 ? styles.MattingOptListMulti : ""}`}>
                    {
                        mattingOptGroups.length > 1 &&
                        <div className={styles.MattingOptListLeft}>
                            {
                                mattingOptGroups.map((item, index) => (
                                    <div
                                        key={item.inputImage}
                                        className={`${styles.MattingOptListLeftItem} ${index == mattingOptIndex ? styles.actived : ""}`}
                                        onClick={() => setMattingOptIndex(index)}
                                    >
                                        <img src={item.inputImage} alt="" />
                                    </div>
                                ))
                            }
                        </div>
                    } {
                        mattingOptGroups.map((item, index) => (
                            <div key={`${item.inputImage}-${index}`} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                <MattingOpt
                                    ref={ref => mattingOptRefs.current[index] = ref}
                                    imageType={imageType}
                                    aiInteractiveNpyId={item.interactiveNpyId}
                                    blueMask={item.foregroundAlphaMask}
                                    whiteMask={item.binaryMask}
                                    inputImage={item.inputImage}
                                    inputImageMultiSemanticId={item.inputImageMultiSemanticId}
                                    getMultiSemanticOutput={getMultiSemanticOutput}
                                />
                            </div>
                        ))
                    }
                </div>
            </PSAIModal>
            <PSAIModal
                title={'账号切换'}
                maxWidth={460}
                closable={false}
                maskClosable={false}
                open={changeUserOpen}
                okText="切换账号"
                cancelText="取消"
                onCancel={() => setChangeUserOpen(false)}
                onOk={() => {
                    setChangeUserOpen(false)
                    eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG })
                }}
            >
                <div className={styles.ChangeUserModalContent}>
                    <p>该功能为企业用户专属,请切换到企业账号使用</p>
                    <p style={{ color: '#5B6673' }}>（切换账号后，当前填写内容将会被清空）</p>
                </div>
            </PSAIModal>
        </>
    )
}

export default InputImageUploader